import { Tag, TagProps } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

interface TightTagProps extends Omit<TagProps, 'children'> {
	children?: ReactNode;
}

/**
 * A tightly styled tag component that ensures the background
 * fits exactly to the text content without excess spacing.
 *
 * This component addresses the issue where the default Tag component's
 * background doesn't properly cover the text on different screen sizes.
 *
 * Commonly used for status labels like "Beta", "Legacy", etc.
 */
export const TightTag: FC<TightTagProps> = ({ children, ...props }) => (
	<Tag
		colorScheme="info"
		size="sm"
		px="6px"
		py="1.5px"
		// Override Chakra UI's default minimum dimensions to allow tight fitting
		minH="unset"
		h="auto"
		w="auto"
		minW="unset"
		lineHeight="1.2"
		fontSize="14px"
		fontWeight="450"
		display="inline-flex"
		alignItems="center"
		justifyContent="center"
		borderRadius="4px"
		whiteSpace="nowrap"
		sx={{
			'& > .chakra-tag__label': {
				padding: '0',
				margin: '0',
			},
		}}
		{...props}
	>
		{children}
	</Tag>
);
